import { FC, useRef, UIEvent, useEffect } from 'react';
import { PaymentMethodId, TransactionEntry } from '@commerce-payment-webcomponents/sdk';
import { ExpiringBalanceDetails } from '@commerce-payment-webcomponents/sdk/services/loyaltyModels/pdp/models/ExpiringBalanceDetails';
import CONSTANTS from '../../../../../../../../constant';
import DrawerTransactionList from '../../../../../transactions-container/components/drawer-transactions-list/DrawerTransactionList';
import styles from './ViewDetail.module.scss';
import { ViewDetailPropTypes } from './types/propTypes';

export const ViewDetail: FC<ViewDetailPropTypes> = ({
  paymentMethodId,
  transactions,
  fetchTransactions,
  fromMultiVoucher,
}: ViewDetailPropTypes) => {
  let timerRef: ReturnType<typeof setTimeout>;
  const containerRef = useRef<HTMLDivElement | null>(null);

  const debouncedScrollHandler = (e: UIEvent<HTMLDivElement>) => {
    if (paymentMethodId !== PaymentMethodId.CreditVoucher) {
      return;
    }
    const fetchRecords = () => {
      const target = e.target as HTMLElement;
      // If user scroll to bottom of the section
      target?.scrollTop >
        target?.scrollHeight - (containerRef.current?.offsetHeight || 0) - CONSTANTS.INFINITE_SCROLL_TRIGGER &&
        transactions.length &&
        fetchTransactions?.();
    };
    clearTimeout(timerRef);
    timerRef = setTimeout(fetchRecords, CONSTANTS.SCROLL_DEBOUNCE_TIME);
  };

  useEffect(() => () => clearTimeout(timerRef), []);

  return (
    <div
      ref={containerRef}
      onScroll={debouncedScrollHandler}
      className={!fromMultiVoucher ? styles['viewDetails-container'] : ''}
      data-testid="transactions-container"
    >
      {transactions?.map((transaction: TransactionEntry & ExpiringBalanceDetails) => (
        <DrawerTransactionList
          key={transaction.amount}
          transaction={transaction}
          paymentId={paymentMethodId}
          fromExpiringSoon={true}
          fromMultiVoucher={fromMultiVoucher}
        />
      ))}
    </div>
  );
};

export type { ViewDetailPropTypes };
